// TO DO: Delete this enum

export enum ContractType {
  CDI = 'CDI',
  CDD = 'CDD',
  INTERNSHIP = 'INTERNSHIP',
  PARTNER = 'PARTNER',
  CONSULTING = 'CONSULTING',
  AVENANT = 'AVENANT',
  AUTRE = 'AUTRE',
}
